import React, { Component } from 'react';
import MainPage from '../MainPage.js'

export class Home extends Component {
    static displayName = Home.name;

    render() {
        return (
            <div>
                <MainPage></MainPage>
            </div>
        );
    }
}
